import React from 'react';

import CanalIncentivo from 'components/Tvendo/Sale/QuotaBPartner/CuotasIncentivos/CanalIncentivos/List';

export default function () {
  return <CanalIncentivo />;
}
